// Contexto mínimo de chart para patron_ruptura_quantum: las páginas del chart
// inyectan el símbolo y timeframe actuales (precedente: setBackendSignal de
// supertrend_quantum en ChartPublicPage). El adapter lo usa para el gating por
// activos/timeframes de la config y para namespacing de ids de señal.
// Nunca es undefined para los consumidores: getChartContext siempre devuelve
// un objeto (posiblemente con claves null antes de la primera inyección).

let currentContext = { symbol: null, timeframe: null }

export function setChartContext(ctx) {
  if (!ctx || typeof ctx !== 'object') return
  currentContext = {
    symbol: typeof ctx.symbol === 'string' ? ctx.symbol : null,
    timeframe: typeof ctx.timeframe === 'string' ? ctx.timeframe : null,
  }
}

export function getChartContext() {
  return currentContext
}
